import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c9666f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "customers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "USERNAME"),
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE COMPLETO"),
  /*#__PURE__*/_createElementVNode("th", null, "CEDULA"),
  /*#__PURE__*/_createElementVNode("th", null, "PUESTO U OCUPACION")
], -1))
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.empleados, (empleado, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: index,
        onClick: ($event: any) => ($options.goToEmpleado(empleado))
      }, [
        _createElementVNode("td", null, _toDisplayString(empleado.username), 1),
        _createElementVNode("td", null, _toDisplayString(empleado.nombreCompleto), 1),
        _createElementVNode("td", null, _toDisplayString(empleado.noIdentificacion), 1),
        _createElementVNode("td", null, _toDisplayString(empleado.puesto), 1)
      ], 8, _hoisted_3))
    }), 128))
  ]))
}